import { LoginUserChangedDialog } from './LoginUserChangedDialog';

export const DialogContainer = () => {
  return (
    <>
      <LoginUserChangedDialog></LoginUserChangedDialog>
    </>
  );
};
